import { ToastContent } from "../../../shared/components";
import { FireServices } from "../../../shared/services/api/fire/FireServices";

export interface PoliceMenuActionDeps {
	toastHandler: any;
	openPolice: (id: string, tab?: string) => void;
	openPdf: (base64: string) => void;
	refreshList: () => void;
	closeMenu: () => void;
	setIsLoading: (v: boolean) => void;
	navigate: (path: string) => void;
	openCancelModal: (id: string) => void;
}

export async function policeMenuActions(
	action: string,
	id: string,
	{
		toastHandler,
		openPolice,
		openPdf,
		refreshList,
		closeMenu,
		setIsLoading,
		navigate,
		openCancelModal,
	}: PoliceMenuActionDeps
) {
	setIsLoading(true);

	try {
		// ================================
		// RENOVAR
		// ================================
		if (action === "renew") {
			navigate("/incendio/orcamento");
			return;
		}

		// ================================
		// DETALHES
		// ================================
		if (action === "details") {
			openPolice(id, "dados");
			return;
		}

		// ================================
		// IMPRESSÕES
		// ================================
		if (action === "print-termo") {
			const { pdfBase64 } = await FireServices.firePolicesPrintTermoAdesao(id);
			openPdf(pdfBase64);
			return;
		}

		if (action === "print-contratada") {
			const { pdfBase64 } = await FireServices.firePolicesPrintContratada(id);
			openPdf(pdfBase64);
			return;
		}

		if (action === "print-apolice") {
			const { pdfBase64 } = await FireServices.firePolicesPrintApolice(id);
			openPdf(pdfBase64);
			return;
		}

		if (action === "print-endosso") {
			const { pdfBase64 } = await FireServices.firePolicesPrintEndosso(id);
			openPdf(pdfBase64);
			return;
		}

		// ================================
		// CANCELAR
		// ================================
		if (action === "cancel") {
			openCancelModal(id);
			return;
		}

		// ================================
		// NOTIFICAÇÃO
		// ================================
		if (action === "sendToNotification") {
			toastHandler.present({
				type: "info",
				messageOrContent: (
					<ToastContent title="Info" content="Notificação não implementada." />
				),
			});
			return;
		}

		// ================================
		// ENVIAR POR E-MAIL
		// ================================
		if (action === "sendPolicy") {
			toastHandler.present({
				type: "info",
				messageOrContent: (
					<ToastContent title="Info" content="Envio de apólice não implementado." />
				),
			});
			return;
		}

		console.warn("Ação desconhecida:", action);
	} catch (error: any) {
		toastHandler.present({
			type: "error",
			messageOrContent: (
				<ToastContent title="Erro" content={error.message ?? "Erro inesperado"} />
			),
		});
	} finally {
		setIsLoading(false);
		closeMenu();
	}
}
